import type { RootState } from 'APP/Store/CreateStore'

export const selectFamilyState = (state: RootState) => state.family
export const selectFamilyMembers = (state: RootState) => state.family.members
